import { cn } from "@/lib/utils";

interface ProgressIndicatorProps {
  current: number;
  total: number;
}

export default function ProgressIndicator({ current, total }: ProgressIndicatorProps) {
  return (
    <div className="flex items-center justify-center gap-2 py-6">
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          className={cn(
            "h-2 w-2 rounded-full transition-all duration-300",
            i === current
              ? "w-6 bg-primary" // Current step: elongated and primary color
              : i < current
              ? "bg-primary/50" // Completed steps: primary with opacity
              : "bg-gray-300/30", // Future steps: gray
          )}
          aria-label={`Step ${i + 1} of ${total}${i === current ? " (current)" : ""}`}
        />
      ))}
    </div>
  );
}
